import { initialize } from "lib/shared/events";

export default { initialize };
